import { createContext, useContext, useState, useCallback } from "react";
import db from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

const SearchContext = createContext();

export function SearchProvider({ children }) {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const performSearch = useCallback(async (text) => {
    const trimmedText = text.trim().toLocaleUpperCase();
    if (!trimmedText) {
      setSearchResults([]);
      return;
    }

    setLoading(true);
    setSearchText(text);

    const q = query(
      collection(db, "listing_aggregations_v1"),
      where("reg", "==", trimmedText)
    );
    const snapshot = await getDocs(q);

    if (snapshot.empty) {
      setSearchResults([]);
    } else {
      const data = [];
      snapshot.forEach((doc) => {
        data.push(doc.data());
      });
      data.sort((a, b) => {
        const aDate = a.last_seen?.toDate ? a.last_seen.toDate() : new Date(a.last_seen || 0);
        const bDate = b.last_seen?.toDate ? b.last_seen.toDate() : new Date(b.last_seen || 0);
        return bDate - aDate;
      });
      setSearchResults(data);
    }
    setLoading(false);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchText("");
    setSearchResults([]);
  }, []);

  return (
    <SearchContext.Provider
      value={{
        searchText,
        setSearchText,
        searchResults,
        loading,
        performSearch,
        clearSearch,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
}

export const useSearch = () => {
  return useContext(SearchContext);
};
